/**
 * fourFortyGlDocumentsReducer.js
 * Created by calhosh on 9/16/2021.
 */

import initialstate from '../initialstate';
import * as actions from '../../actions/actiontypes';
import utilityfunctions from '../../util/utilityfunctions';

export default function fourFortyGlDocumentsReducer(state = initialstate.fourFortyGlDocuments, action) {
	let newState;

	switch (action.type) {
		// doc download --> Add the current document to the list
		case actions.KRONOS_DOCHELPER_DOWNLOAD_DOCUMENT: {
			if (action.meta && action.meta.docHelper && action.meta.docHelper.payload) {
				const payload = action.meta.docHelper.payload;
				let documents = initializeDocuments(state);

				documents = {
					byId: {
						...documents.byId,
						[payload.documentId.toUpperCase()]: payload
					},
					allIds: [...documents.allIds, payload.documentId.toUpperCase()]
				};

				newState = {
					...state,
					documents: documents
				};
			}

			break;
		}
		case actions.SET_CHANGE_REASON_REQUIRED: {
			newState = {
				...state,
				isChangeReasonRequired:
					action.isChangeReasonRequired !== undefined ? action.isChangeReasonRequired : state.isChangeReasonRequired,
				showChangeReasonModal: action.showChangeReasonModal,
				entityUid: action.entityUid
			};
			return newState;
		}
		case actions.SHOW_CHANGE_REASON_MODAL: {
			let newDocuments;
			const currentDocId = action.documentId?.toUpperCase();

			// The user has entered a change reason. Remove the documentId from the store.
			if (!action.showChangeReasonModal && currentDocId) {
				newDocuments = {
					byId: {
						...state.documents.byId,
						[currentDocId]: undefined
					},
					allIds: state.documents.allIds.filter((docId) => docId !== currentDocId)
				};
			}

			newState = {
				...state,
				showChangeReasonModal: action.showChangeReasonModal,
				uploadDocumentId: action.showChangeReasonModal ? currentDocId : null,
				documents: newDocuments ? newDocuments : state.documents
			};
			return newState;
		}
		/* ******************************* Document helper actions ******************************** */
		// case actions.DOCHELPER_UPLOAD_DOCUMENT:
		// case actions.DOCUMENT_UPLOAD_PROGRESS:
		// case 'DOCUMENT_UPLOAD_COMPLETE':
		// case 'DOCUMENT_DOWNLOAD_PROGRESS':
		// case 'DOCUMENT_DOWNLOAD_COMPLETE':
		// case 'API_ERROR': {
		// 	console.log('❂❂❂❂❂❂ 440GL dochelper action: ', action);

		// 	break;
		// }

		default:
			return state;
	}

	return newState ? newState : state;
}

function initializeDocuments(state) {
	let documents;
	if (state.documents) {
		documents = {
			byId: {...state.documents.byId},
			allIds: [...state.documents.allIds]
		};
	} else {
		documents = utilityfunctions.normalize();
	}
	return documents;
}
